import React, {Component} from 'react';
import {connect} from "react-redux";

import { ToastContainer, toast } from 'react-toastify';

import {InfoBox, GoogleMap, Marker, Polygon, StyledMapWithAnInfoBox, Wkt} from '../base/map';
import Title from '../base/title';
import Dropdown from '../base/dropdown';
import api from '../../utils/api';
import {helpers} from '../../utils/helpers';

class CloseStations extends Component {

  constructor(props) {
    super(props);

    let allowedGroups = [helpers.groups.ADMINISTRATOR, helpers.groups.PRICING_STAFF];
    let canEditPM = helpers.checkUserGroup(allowedGroups, this.props.user);

    this.state = {
      opened: true,
      loader: ' loader-box',
      loadMap: false,
      marker: {
        PM: {},
        SM: {}
      },
      bocas: {
        SHELL: [],
        YPF: [],
        AXION: [],
        PETROBRAS: [],
        OTRAS: []
      },
      zone: {
        SHELL: [],
        YPF: [],
        AXION: [],
        PETROBRAS: [],
        OTRAS: []
      },
      station: {
        zone: {
          area: {}
        },
        company: {}
      },
      currentMarker: {},
      canEditPM
    };
    this.removeItem = this.removeItem.bind(this);
    this.mapRender = this.mapRender.bind(this);
    this.setStationAs = this.setStationAs.bind(this);
    this.loadMapData = this.loadMapData.bind(this);
  }

  mapRender(props) {
    let _self = this;
    if (!props.loadMap) return '';

    let polygon = [];
    if (props.polygon) {
      let wkt = new Wkt.Wkt();
      wkt.read(props.polygon.split(';')[1]);
      wkt.toJson().coordinates[0][0].forEach(cord => {
        polygon.push({ lat: cord[1], lng: cord[0] });
      });
    }

    // center in current station
    let center = { lat: parseFloat(_self.state.station.latitude), lng: parseFloat(_self.state.station.longitude)};

    // let bocasKeys = Object.keys(props.bocas);
    // for(let i = 0; i < bocasKeys.length; i++) {
    //   for (let v = 0; v < props.bocas[bocasKeys[i]].length; v++) {
    //     center = { lat: parseFloat(props.bocas[bocasKeys[i]][v].latitude), lng: parseFloat(props.bocas[bocasKeys[i]][v].longitude) };
    //     break;
    //   }
    // }

    if (!center && props.prime_marker.id) center = { lat: parseFloat(props.prime_marker.latitude), lng: parseFloat(props.prime_marker.longitude) };
    if (!center && props.secondary_marker.id) center = { lat: parseFloat(props.secondary_marker.latitude), lng: parseFloat(props.secondary_marker.longitude) };

    return <GoogleMap defaultOptions={{ styles: props.myStyle }} defaultZoom={14} defaultCenter={center}>
      {props.polygon && <Polygon path={polygon} />}
      {_self.state.station && <Marker icon={{url: api.marker(_self.state.station.brand.selected_map_marker)}} key={_self.state.station.id} position={{ lat: parseFloat(_self.state.station.latitude), lng: parseFloat(_self.state.station.longitude) }} onClick={ () => { _self.setState({ currentMarker: _self.state.station }); } }>
          {props.currentMarker.id === _self.state.station.id && <InfoBox onCloseClick={ () => { _self.setState({ currentMarker: {} }); } } options={{ closeBoxURL: '', enableEventPropagation: true }}>
            <div className="info-box">
              <h2>{_self.state.station.brand.name.toLowerCase().includes('shell') ? ('Shell ' + _self.state.station.global_code + ' (' + _self.state.station.inscription_number + ')') : _self.state.station.brand.name + " " + _self.state.station.inscription_number}<span onClick={ () => { _self.setState({ currentMarker: {} }); } }>X</span></h2>
              <p>{_self.state.station.address}</p>
              <p className="mb-2">{_self.state.station.company ? _self.state.station.company.cuit : ''}</p>
              {_self.state.station.last_prices.map(price => {
                return <p>{price.product_shortname} ${price.pvp ? price.pvp : " -"}</p>
              })}
            </div>
          </InfoBox>}
      </Marker>}
      {props.prime_marker && props.prime_marker.brand  && <Marker icon={{url: api.marker(props.prime_marker.brand.pm_map_marker)}} key={props.prime_marker.id} position={{ lat: parseFloat(props.prime_marker.latitude), lng: parseFloat(props.prime_marker.longitude) }} onClick={ () => { _self.setState({ currentMarker: props.prime_marker }); } }>
          {props.currentMarker.id === props.prime_marker.id && <InfoBox onCloseClick={ () => { _self.setState({ currentMarker: {} }); } } options={{ closeBoxURL: '', enableEventPropagation: true }}>
            <div className="info-box">
              <h2>{props.prime_marker.brand.name.toLowerCase().includes('shell') ? ('Shell ' + props.prime_marker.global_code + ' (' + props.prime_marker.inscription_number + ')') : props.prime_marker.brand.name + " " + props.prime_marker.inscription_number}<span onClick={ () => { _self.setState({ currentMarker: {} }); } }>X</span></h2>
              <p>{props.prime_marker.address}</p>
              <p className="mb-2">{props.prime_marker.company ? props.prime_marker.company.cuit : ''}</p>
              {props.prime_marker.last_prices.map(price => {
                return <p>{price.product_shortname} ${price.pvp ? price.pvp : " -"}</p>
              })}
              <div className="buttns">
                {_self.state.canEditPM &&
                <button className="active" onClick={ () => { props.setStationAs(props.prime_marker.index, 'prime-marker'); } }>PM</button>}
                <button onClick={ () => { props.setStationAs(props.prime_marker.id, 'secondary-marker'); } }>SM</button>
                <button onClick={ () => { props.setStationAs(props.prime_marker.id, 'nearby-marker'); } }>ZONA</button>
              </div>
            </div>
          </InfoBox>}
      </Marker>}
      {props.secondary_marker && props.secondary_marker.brand && <Marker icon={{url: api.marker(props.secondary_marker.brand.sm_map_marker)}} key={props.secondary_marker.id} position={{ lat: parseFloat(props.secondary_marker.latitude), lng: parseFloat(props.secondary_marker.longitude) }} onClick={ () => { _self.setState({ currentMarker: props.secondary_marker }); } }>
          {props.currentMarker.id === props.secondary_marker.id && <InfoBox onCloseClick={ () => { _self.setState({ currentMarker: {} }); } } options={{ closeBoxURL: '', enableEventPropagation: true }}>
            <div className="info-box">
              <h2>{props.secondary_marker.brand.name.toLowerCase().includes('shell') ? ('Shell ' + props.secondary_marker.global_code + ' (' + props.secondary_marker.inscription_number + ')') : props.secondary_marker.brand.name + " " + props.secondary_marker.inscription_number}<span onClick={ () => { _self.setState({ currentMarker: {} }); } }>X</span></h2>
              <p>{props.secondary_marker.address}</p>
              <p className="mb-2">{props.secondary_marker.company ? props.secondary_marker.company.cuit : ''}</p>
              {props.secondary_marker.last_prices.map(price => {
                return <p>{price.product_shortname} ${price.pvp ? price.pvp : " -"}</p>
              })}
              <div className="buttns">
                {_self.state.canEditPM &&
                <button onClick={ () => { props.setStationAs(props.secondary_marker.id, 'prime-marker'); } }>PM</button>}
                <button className="active" onClick={ () => { props.setStationAs(props.secondary_marker.id, 'secondary-marker'); } }>SM</button>
                <button onClick={ () => { props.setStationAs(props.secondary_marker.id, 'nearby-marker'); } }>ZONA</button>
              </div>
            </div>
          </InfoBox>}
      </Marker>}
      {Object.keys(props.bocas).map(index => {
        return props.bocas[index].map(boca => {
          return <Marker key={boca.id} icon={{url: api.marker(boca.brand.map_marker)}} position={{ lat: parseFloat(boca.latitude), lng: parseFloat(boca.longitude) }} onClick={ () => { _self.setState({ currentMarker: boca }); } }>
              {props.currentMarker.id === boca.id && <InfoBox onCloseClick={ () => { _self.setState({ currentMarker: {} }); } } options={{ closeBoxURL: '', enableEventPropagation: true }}>
                <div className="info-box">
                  <h2>{boca.brand.name.toLowerCase().includes('shell') ? ('Shell ' + boca.global_code + ' (' + boca.inscription_number + ')') : boca.brand.name + " " + boca.inscription_number}<span onClick={ () => { _self.setState({ currentMarker: {} }); } }>X</span></h2>
                  <p>{boca.address}</p>
                  <p className="mb-2">{boca.company.cuit}</p>
                  {boca.last_prices.map(price => {
                    return <p>{price.product_shortname} ${price.pvp ? price.pvp : " -"}</p>
                  })}
                  <div className="buttns">

                    {boca.brand.minem_id !== 4 && _self.state.canEditPM ? <button onClick={ () => { props.setStationAs(boca.id, 'prime-marker'); } }>PM</button> : ''}
                    <button onClick={ () => { props.setStationAs(boca.id, 'secondary-marker'); } }>SM</button>
                    <button className="active" onClick={ () => { props.setStationAs(boca.id, 'nearby-marker'); } }>ZONA</button>
                  </div>
                </div>
              </InfoBox>}

          </Marker>
        })
      })}
    </GoogleMap>
  }

  loadMapData() {
    let _self = this;
    api.get('stations/id/' + this.props.station.id).then(resp => {
      let _zones = {
        SHELL: [],
        YPF: [],
        AXION: [],
        PETROBRAS: [],
        OTRAS: []
      };
      let bocas = {
        SHELL: [],
        YPF: [],
        AXION: [],
        PETROBRAS: [],
        OTRAS: []
      };


      if (resp.data.nearby_markets) {
        resp.data.nearby_markets.forEach(station => {
          let key = 'OTRAS';
          if (station.brand.name.indexOf('SHELL') >= 0) key = 'SHELL';
          else if (station.brand.name.indexOf('YPF') >= 0) key = 'YPF';
          else if (station.brand.name.indexOf('AXION') >= 0) key = 'AXION';
          else if (station.brand.name.indexOf('PETROBRAS') >= 0) key = 'PETROBRAS';

          if (key) _zones[key].push(station);
          if (key) bocas[key].push(station);
        });
      }

      api.get('stations/id/' + this.props.station.id + '/complements/').then(resp2 => {
        resp2.data.five_kilometers_stations && resp2.data.five_kilometers_stations.forEach(station => {
          let key = 'OTRAS';
          if (station.brand.name.indexOf('SHELL') >= 0) key = 'SHELL';
          else if (station.brand.name.indexOf('YPF') >= 0) key = 'YPF';
          else if (station.brand.name.indexOf('AXION') >= 0) key = 'AXION';
          else if (station.brand.name.indexOf('PETROBRAS') >= 0) key = 'PETROBRAS';

          if (key) bocas[key].push(station);
        });

        _self.setState({ 
          station: resp.data,
          marker: {
            PM: resp.data.prime_marker ? resp.data.prime_marker : false,
            SM: resp.data.secondary_marker ? resp.data.secondary_marker : false
          },
          zone: _zones,
          bocas: bocas,
          loader: '',
          loadMap: true
        });
      });
    })
  }

  componentDidMount() {
    this.loadMapData();
  }

  removeItem(key, item) {
    let _self = this;
    for (let i = 0; i < _self.state.zone[key].length; i++) {
      if (_self.state.zone[key][i].id === item.id) {
        _self.state.zone[key].splice(i, 1);
      }
    }
    api.delete('stations/id/' + _self.state.station.id + '/nearby-marker/', {
      nearby_marker: item.id
    }).then(resp => {
      _self.setState({ zone: _self.state.zone });
    })
  }

  // types: [nearby-marker,prime-marker,prime-marker]
  setStationAs(id, type) {
    let _self = this;
    let data = {};
    data[type.replace('-', '_')] = id;
    api.put('stations/id/' + this.props.station.id + '/' + type + '/', data).then(resp => {
      _self.loadMapData();
      let msg = 'Se actualizo el secondary marker!';
      if (type === 'nearby-marker') msg = 'Se actualizo la zona de influencia!';
      if (type === 'prime-marker') msg = 'Se actualizo el prime marker!';
      toast.success(msg);
    })
  }

  goToStation = (id) =>{
    window.location = '/analisis/estacion/' + id
  };

  render() {
    let _self = this;
    return <div className="row close-station">
        <ToastContainer />
        <Title isOpen={_self.state.opened} toggle={() => { _self.setState({ strategy: {}, opened: !_self.state.opened }, function() { if (_self.state.opened) _self.componentDidMount(); }); }} text="ESTACIONES CERCANAS" isGray={true} hasIcon={true} />
        {_self.state.opened && <div className="row">
          <div className="col s12">
            <div className="row">
              <div className={"pumps" + this.state.loader}>
                <div className="col s5 no-gutter">
                  <div className="pumps-container">
                    <Dropdown text='MARKERS' items={[{}]} getItem={() => {}} noIcon />
                    <ul className='pumps-list'>
                      {Object.keys(this.state.marker).map(markerKey => {
                        return <li key={markerKey} onClick={()=>this.goToStation(_self.state.marker[markerKey].id)}>
                          {_self.state.marker[markerKey].brand && <img alt="" src={api.marker(_self.state.marker[markerKey].brand[markerKey === 'PM' ? 'pm_map_marker' : 'sm_map_marker'])} className="fas fa-map-marker-alt" />}
                          <b>{_self.state.marker[markerKey].inscription_number ? _self.state.marker[markerKey].inscription_number : 'No posee'}</b>
                          <span>{_self.state.marker[markerKey].address ? _self.state.marker[markerKey].address : '-'}</span>
                          <span className="distance">{_self.state.marker[markerKey].distance ? _self.state.marker[markerKey].distance : '-'}</span>
                          <i className="holder"></i>
                        </li>
                      })}
                    </ul>
                    <Dropdown text='ZONA DE INFLUENCIA' items={[{}]} getItem={() => {}} noIcon />
                    <ul className='pumps-list'>
                      {Object.keys(this.state.zone).map(key => {
                        return _self.state.zone[key].map(boca => {
                          return <li key={boca.id}>
                            {boca.brand && <img alt="" src={api.marker(boca.brand.map_marker)} className="fas fa-map-marker-alt" onClick={() => { _self.props.showStation(boca) } } /> }
                            <b onClick={() => { _self.props.showStation(boca) } }>{boca.inscription_number}</b>
                            <span onClick={() => { _self.props.showStation(boca) } }>{boca.address}</span>
                            <span onClick={() => { _self.props.showStation(boca) } } className="distance">{boca.distance ? boca.distance : '-'}</span>
                            <i onClick={ () => { _self.removeItem(key, boca); } } className="fas fa-times"></i>
                          </li>
                        })
                      })}
                    </ul>
                  </div>
                </div>
                <div className="col s7 no-gutter">
                  <StyledMapWithAnInfoBox setStationAs={this.setStationAs} currentMarker={this.state.currentMarker} renderMethod={this.mapRender} loadMap={this.state.loadMap} polygon={this.state.station.pricing_cluster ? this.state.station.pricing_cluster.polygon : false} bocas={this.state.bocas} prime_marker={this.state.marker.PM} secondary_marker={this.state.marker.SM} />
                  <div className="selected-data">
                    <div className="row">
                      <div className="col s4 no-gutter">
                        <b>CLUSTER</b>
                      </div>
                      <div className="col s4 no-gutter">
                        <b>AREA - ZONA</b>
                      </div>
                      <div className="col s4 no-gutter">
                        <b>PROVINCIA</b>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col s4 no-gutter">
                        <div className="selected-data-holder">
                          <img alt="" src="/static/imgs/angle-right.svg" />
                          <span>{this.state.station.pricing_cluster ? this.state.station.pricing_cluster.name : '-'}</span>
                        </div>
                      </div>
                      <div className="col s4 no-gutter">
                        <div className="selected-data-holder">
                          <div>
                            <img alt="" src="/static/imgs/angle-right.svg" />
                            <span>{this.state.station.zone ? this.state.station.zone.area.name : '-'}</span>
                          </div>
                          <div>
                            <img alt="" src="/static/imgs/angle-right.svg" />
                            <span>{this.state.station.zone ? this.state.station.zone.name : '-'}</span>
                          </div>
                        </div>
                      </div>
                      <div className="col s4 no-gutter">
                        <div className="selected-data-holder">
                          <div>
                            <img alt="" src="/static/imgs/angle-right.svg" />
                            <span>{this.state.station.province ? this.state.station.province.name: '-'}</span>
                          </div>
                        </div>
                      </div>
                    </div>  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
      </div>
  }

}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

export default connect(mapStateToProps)(CloseStations);



// WEBPACK FOOTER //
// ./src/containers/analisis/closestations.js